import React from 'react';

import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  gap: 6px;
  color: var(--text-secondary);

  .title {
    text-align: center;
    font-family: var(--font-bold);
    font-size: 18px;
  }
  .description {
    text-align: center;
    font-size: 14px;
  }
`;

const CommunityAdminContentCompetitorsListEmpty = () => {
  return (
    <Container>
      <span className={'title'}>There are no competitors.</span>
      <span className={'description'}>
        Use the search above to add competitors to this community.
        <br />
        Competitors appear on various community screens.
      </span>
    </Container>
  );
};

export default CommunityAdminContentCompetitorsListEmpty;
